import { render, staticRenderFns } from "./Writings.vue?vue&type=template&id=e4ce1f56&"
import script from "./Writings.vue?vue&type=script&lang=js&"
export * from "./Writings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports